module.exports = __webpack_public_path__ + "static/media/no_result_found.0c38f3b9.png";